import { buildDashboardTabNotificationsPath } from "../utils/dashboardTabNotifications";

const MODULE_TO_TAB = {
  quality_inspection: "open_requests",
  auction: "open_requests",
};

const TYPE_TO_TAB = {
  rfq_received: "open_requests",
  qa_request_received: "open_requests",
  quotation_submitted: "quotations",
  qa_quote_submitted: "quotations",
  inspection_scheduled: "inspections",
  inspection_assigned: "inspections",
  inspection_in_progress: "inspections",
  inspection_completed: "completed",
  qa_report_submitted: "reports",
  qa_report_due: "reports",
};

const SCOPED_MODULES = new Set(Object.keys(MODULE_TO_TAB));

export function resolveQualityTabForNotificationType(notificationType) {
  const key = String(notificationType || "").trim().toLowerCase();
  return TYPE_TO_TAB[key] || null;
}

export function resolveQualityTabForNotification(notification) {
  if (!notification) return null;
  const moduleName = String(notification.module_name || "").toLowerCase();
  if (!SCOPED_MODULES.has(moduleName)) return null;
  const type = String(notification.notification_type || "").toLowerCase();
  return TYPE_TO_TAB[type] || MODULE_TO_TAB[moduleName] || null;
}

export function notificationBelongsToQualityTab(notification, tabKey) {
  if (!notification || !tabKey || tabKey === "overview") {
    return SCOPED_MODULES.has(String(notification?.module_name || "").toLowerCase());
  }
  if (String(notification.module_name || "") !== "quality_inspection" && String(notification.module_name || "") !== "auction") {
    return false;
  }
  return resolveQualityTabForNotification(notification) === tabKey;
}

export function buildQualityTabNotificationsPath(tabKey) {
  return buildDashboardTabNotificationsPath({ dashboard: "qa", tabKey, moduleName: "quality_inspection" });
}
